export default "__VITE_ASSET__CSN7iE_p__"